module.exports = __webpack_public_path__ + "static/media/kerstman-door-het-ijs-4.7fee1508.jpeg";